import React, {useState, useEffect} from "react";
import {useParams, useHistory, Link} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import { RadioButton } from 'primereact/radiobutton';

// service
import {ChequeCultureLegacy} from "../../legacyforms/ChequeCultureLegacy";
import {setASExercice, setCAS, setListActionSociale} from "../../../store/actions/actionSociale";
import {ActionSocialeService} from "../../../service/ActionSocialeService";
import { LinkProviderService } from "../../../service/LinkProviderService";

// actions
import { getUsagerInfo } from "../../../store/actions/usager";

// scss
import "../clap/FormulaireClap.scss";

export const ChoixRib = () => {
    const { codeCas } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();

    const [skip, setSkip] = useState(true);
    const [loadInit, setLoadInit] = useState(false);
    const [displayBasic, setDisplayBasic] = useState(false);

    const linkService = new LinkProviderService();




    useEffect(() => {
            history.push("/DemandeChangementRib/create");
    });

    return (
        <div className="grid cld-width" style={{marginTop: "1%"}}>
            <ChequeCultureLegacy />
            <div className="col-12 mx-auto">
                <div className="no_shadow_no_border card " style={{display: !displayBasic ? "block" : "none"}}>
                    <nav aria-label="breadcrumb" class="pt-3">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href={linkService.getRetourEaAccueilAgent()} target="_self">
                                    Espace Agent
                                </a>
                            </li>

                            <li className="breadcrumb-item">
                                <a href={linkService.getRetourEaMembrePrestation()}
                                   target="_self">
                                    Mes infos
                                </a>
                            </li>


                            <li className="breadcrumb-item">
                                <a href={linkService.getRetourEaMembrePrestation()}
                                   target="_self">
                                    Références bancaires
                                </a>
                            </li>

                            <li aria-current="page" className="breadcrumb-item active">
                                Modifier
                            </li>
                        </ol>
                    </nav>
                    <p></p>
                    <h2
                        className="cld-h2"
                        style={{marginTop: "2%", marginBottom: "2%"}}
                    >
                        La période concernée
                    </h2>
                    <div
                        style={{
                            backgroundColor: "#E9ECEF",
                            paddingLeft: "1%",
                            paddingTop: "1%",
                            paddingBottom: "2%",
                            borderRadius: "5px",
                        }}
                    >
                        <p style={{color: "#000", fontSize: "14px"}}>
                            Ma demande concerne des dépenses effectuées durant l'année
                        </p>

                    </div>
                </div>
            </div>
        </div>
    );
};
